import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'
import { StatesConfig } from 'xstate'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandGlobalStore } from 'zustandGlobalStore'

const getHasEmail = () => !!useZustandGlobalStore.getState().lead?.email
const getHasSubscription = () => {
  const userSubscriptions = useZustandGlobalStore.getState().lead?.subscriptions
  return !!userSubscriptions?.find(
    (subscription) => !['created', 'cancelled'].includes(subscription.status),
  )
}

export const getXStateConfigWoofzWa1 = (
  pages: TStep[],
): StatesConfig<any, any, any> => ({
  initial: {
    // Pay attention to the order of the conditions!
    always: [
      // Cover case when page was reloaded or connection was lost
      // during the purchase polling
      {
        cond: (): boolean => !!useZustandGlobalLocalStore.getState().purchaseId,
        target:
          useZustandGlobalLocalStore.getState().purchasePageId ||
          pages[0].pageId,
      },
      {
        cond: (): boolean => getHasSubscription(),
        target: PageId.DOWNLOAD_WA1,
      },
      {
        cond: (): boolean => getHasEmail(),
        target: PageId.SUBSCRIPTIONS_WA1,
      },
      {
        target: pages[0].pageId, // Always transition to first page as fallback
      },
    ],
  },
  ...pages.reduce(
    (acc, page, index) => ({
      ...acc,
      [page.pageId]: {
        on: {
          NEXT_FLOW_STEP: {
            target: pages[index + 1]?.pageId,
          },
          PREVIOUS_FLOW_STEP: {
            target:
              index - 1 >= 0 ? pages[index - 1].pageId : pages[index].pageId,
          },
          ...(page.pageId === PageId.SUBSCRIPTIONS_WA1 && {
            NEXT_FLOW_STEP: {
              target: PageId.DOWNLOAD_WA1,
            },
            PREVIOUS_FLOW_STEP: {
              target: PageId.CANCEL_OFFER_WA1,
            },
          }),
          ...(page.pageId === PageId.CANCEL_OFFER_WA1 && {
            NEXT_FLOW_STEP: {
              target: PageId.DOWNLOAD_WA1,
            },
            PREVIOUS_FLOW_STEP: {
              target: PageId.CANCEL_OFFER_WA1,
            },
          }),
        },
      },
    }),
    {} as StatesConfig<any, any, any>,
  ),
  [PageId.DOWNLOAD_WA1]: {
    type: 'final',
  },
})
